<template>
  <a-select
    v-model:value="selectValue"
    @change="handleSelect"
    :placeholder="props.placeholder"
    :options="selectOptions"
    :style="props.style ? props.style : 'width: 500px'"
    allowClear
  >
  </a-select>
</template>

<script>
import { computed, defineComponent, ref, watch } from "vue";
import {
  seriousnessList,
  frequencyList,
  recurrentList,
  processesList,
} from "@/views/trialProductionCenter/failureanalysis/component/selectOption";

export default defineComponent({
  props: {
    type: String,
    value: Number,
    placeholder: String,
    style: String,
  },
  setup(props, context) {
    const optionMapping = {
      serious: seriousnessList,
      frequency: frequencyList,
      recurrent: recurrentList,
      processes: processesList,
    };

    const selectOptions = computed(() => {
      const list = [];
      if (props.type && optionMapping[props.type]) {
        list.push(...optionMapping[props.type]);
      }

      return list;
    });

    const selectValue = ref(null);

    const handleSelect = (e) => {
      context.emit("handleSelect", e);
    };

    watch(
      () => props.value,
      (val) => {
        // console.log(val);
        if (val) {
          selectValue.value = val;
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      selectValue,
      selectOptions,
      handleSelect,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
